class PrivacyModal extends HTMLElement {
  constructor() {
    super();
    this.modalContent = null;
    this.isLoading = false;
    this.maxRetries = 10;
    this.retryDelay = 1000; // 1 second
  }

  async waitForShopifyAPI(retryCount = 0) {
    
    if (window.Shopify && window.Shopify.customerPrivacy) {
      return true;
    }

    if (retryCount >= this.maxRetries) {
      return false;
    }

    return new Promise(resolve => {
      setTimeout(async () => {
        const result = await this.waitForShopifyAPI(retryCount + 1);
        resolve(result);
      }, this.retryDelay);
    });
  }

  async checkRegion() {
    
    const apiAvailable = await this.waitForShopifyAPI();
    if (!apiAvailable) {
      return false;
    }

    const region = window.Shopify.customerPrivacy.getRegion();
    return region === 'USCA';
  }

  createModalContent() {
    this.modalContent = `
      <modal-dialog id="PrivacyModal" class="product-popup-modal">
        <div role="dialog" aria-label="Do Not Sell or Share My Personal Info" aria-modal="true" class="product-popup-modal__content" tabindex="-1">
          <button id="ModalClose-Privacy" type="button" class="product-popup-modal__toggle" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
            </svg>
          </button>
          <div class="product-popup-modal__content-info">
            <div class="privacy-modal">
              <h2 class="privacy-modal__title">Opt Out</h2>
              <p class="privacy-modal__text">
                Baltic Born cares about your privacy. We work with interest-based third-party companies in order to provide you with personalized advertisements. Complete the form below to opt-out of selling or sharing your personal information.
              </p>
              <p class="privacy-modal__text">
                Learn more about how we use and protect your data in our <a href="/pages/privacy-policy" class="privacy-modal__link">Privacy Policy</a>.
              </p>

              <div id="pc--opt-out-form-container">
                <form action="/dns_opt_out" class="privacy-modal__form" method="POST" id="pc--opt-out-form" accept-charset="UTF-8">
                  <input type="hidden" id="pc_return_to" name="return_to" value="">
                  <div class="privacy-modal__form-field">
                    <label class="privacy-modal__label">Email Address Collection</label>
                    <input id="pc--opt-out-email_input" class="privacy-modal__input" type="email" name="opt_out_email" value="" required aria-required="true" autocorrect="off" autocapitalize="off" autocomplete="email">
                    
                    <div id="hcaptcha" class="h-captcha" data-sitekey="b2f59229-c8ff-461c-8062-5d9a4408eb20" data-callback="submitOptOutForm" data-size="invisible"></div>
                  </div>

                  <div class="privacy-modal__buttons">
                    <button type="submit" class="privacy-modal__submit" name="pc--commit" id="pc--opt-out-button">
                      Do Not Sell Or Share My Info
                    </button>
                    <button type="button" class="privacy-modal__cancel" onclick="document.getElementById('PrivacyModal').hide()">
                      Cancel
                    </button>
                  </div>

                  <p class="privacy-modal__note">
                    Please note an opt-out is device and browser-specific and blocking or clearing cookies may remove the opt-out settings.
                  </p>
                </form>
              </div>

              <div id="pc--opt-out-success" class="privacy-modal__message privacy-modal__message--success" style="display: none;">
                <svg aria-hidden="true" focusable="false" class="icon icon-success" viewBox="0 0 13 13">
                  <path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"></path>
                  <path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"></path>
                  <path d="M4.10645 6.7688L6.13766 8.62553" stroke="white"></path>
                </svg>
                <span>Opted-out successfully</span>
              </div>

              <div id="pc--opt-out-error" class="privacy-modal__message privacy-modal__message--error" style="display: none;">
                <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                  <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                  <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                  <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                  <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
                </svg>
                <span>A problem occurred, try submitting your email again</span>
              </div>
            </div>
          </div>
        </div>
      </modal-dialog>

      <style>
        .privacy-modal {
          padding: 2rem;
          max-width: 500px;
          margin: 0 auto;
          text-align: center;
        }

        .privacy-modal__title {
          font-size: 24px;
          margin-bottom: 1.5rem;
          font-weight: 500;
        }

        .privacy-modal__text {
          margin-bottom: 1rem;
          line-height: 1.5;
        }

        .privacy-modal__link {
          color: #000;
          text-decoration: underline;
        }

        .privacy-modal__form {
          margin-top: 2rem;
        }

        .privacy-modal__form-field {
          margin-bottom: 1.5rem;
          text-align: left;
        }

        .privacy-modal__label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }

        .privacy-modal__input {
          width: 100%;
          padding: 0.75rem;
          border: 1px solid #ddd;
          margin-bottom: 0.25rem;
        }

        .privacy-modal__required {
          color: #cc0000;
          font-size: 0.875rem;
        }

        .privacy-modal__buttons {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: 2rem;
        }

        .privacy-modal__submit,
        .privacy-modal__cancel {
          width: 100%;
          padding: 1rem;
          border: none;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .privacy-modal__submit {
          background-color: #cb8884;
          color: #fff;
        }

        .privacy-modal__submit:hover {
          background-color: #333;
        }

        .privacy-modal__cancel {
          background-color: #fff;
          border: 1px solid #ddd;
          color: #000 !important;
        }

        .privacy-modal__cancel:hover {
          background-color: #f5f5f5;
        }

        .privacy-modal__note {
          margin-top: 1.5rem;
          font-size: 0.875rem;
          color: #666;
        }

        .privacy-modal__message {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          padding: 1rem;
          margin-top: 1rem;
          border-radius: 4px;
        }

        .privacy-modal__message--success {
          background-color: #f1f8f5;
          color: #428445;
        }

        .privacy-modal__message--error {
          background-color: #fff8f8;
          color: #cc0000;
        }

        .privacy-modal__message .icon {
          width: 20px;
          height: 20px;
        }

        #PrivacyModal .product-popup-modal__content{
          height: fit-content;
          max-height: 100%;
        }

        #PrivacyModal .product-popup-modal__content-info {
          padding-right: 0 !important;
        }

        #PrivacyModal .product-popup-modal__toggle{
          border: none;
        }

        @media screen and (min-width: 768px) {
          .privacy-modal__buttons {
            flex-direction: row;
          }
        }

        @media screen and (min-width: 750px) {
            #PrivacyModal .product-popup-modal__content {
                width: unset;
            }
        }
      </style>
    `;

    document.body.insertAdjacentHTML('beforeend', this.modalContent);
  }

  async showModal() {
    // const isUSCA = await this.checkRegion();
    // console.log('Region check result:', isUSCA);
    // if (!isUSCA) {
    //   console.log('Not in correct region, returning');
    //   return;
    // }

    if (!this.modalContent) {
      this.createModalContent();
    }

    // Find the modal and show it
    const modal = document.getElementById('PrivacyModal');
    if (modal) {
      modal.show();

      // Initialize the form functionality
      this.initializeForm();
    }
  }

  initializeForm() {
    
    // Load hCaptcha script
    if (!document.querySelector('script[src*="hcaptcha"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.hcaptcha.com/1/api.js?onload=optOutOnLoad';
      script.defer = true;
      document.body.appendChild(script);
    }

    // Define form functions
    window.getUrlParam = function(paramName) {
      var queryString = window.location.search.slice(1);
      var paramsArray = queryString.split('&');
      var paramValue = null;
      for (var i = 0; i < paramsArray.length; i++) {
        var param = paramsArray[i];
        var keyValuePair = param.split('=');
        var key = keyValuePair[0];
        if (key === paramName) {
          paramValue = decodeURIComponent(keyValuePair[1]);
          break;
        }
      }
      return paramValue;
    };

    window.submitOptOutForm = function() {
      const form = document.getElementById('pc--opt-out-form');
      const formData = new FormData(form);
      
      fetch('/dns_opt_out', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (response.ok) {
          showSuccessMessage();
          form.reset();
        } else {
          showErrorMessage();
        }
      })
      .catch(error => {
        showErrorMessage();
      });
    };

    window.showSuccessMessage = function() {
      const successMessage = document.getElementById('pc--opt-out-success');
      const errorMessage = document.getElementById('pc--opt-out-error');
      const formContainer = document.getElementById('pc--opt-out-form-container');
      
      // Hide error message if visible
      errorMessage.style.display = 'none';
      
      // Hide form
      formContainer.style.display = 'none';
      
      // Show success message
      successMessage.style.display = 'flex';
    };

    window.showErrorMessage = function() {
      const successMessage = document.getElementById('pc--opt-out-success');
      const errorMessage = document.getElementById('pc--opt-out-error');
      const formContainer = document.getElementById('pc--opt-out-form-container');
      
      // Hide success message if visible
      successMessage.style.display = 'none';
      
      // Show form for retry
      formContainer.style.display = 'block';
      
      // Show error message
      errorMessage.style.display = 'flex';
      
      // Hide error message after 5 seconds
      setTimeout(() => {
        errorMessage.style.display = 'none';
      }, 5000);
    };

    window.showNotApplicableMessage = function() {
      document.getElementById('pc--opt-out-not-applicable').style.display = 'block';
    };

    window.setupForm = function() {
      var formContainer = document.getElementById('pc--opt-out-form-container');
      formContainer.style.display = 'block';
      
      // Set return_to to current path
      var pcReturnTo = document.getElementById("pc_return_to");
      pcReturnTo.setAttribute("value", window.location.pathname);
      
      // Reset form state
      const form = document.getElementById('pc--opt-out-form');
      form.reset();
      
      // Hide any existing messages
      document.getElementById('pc--opt-out-success').style.display = 'none';
      document.getElementById('pc--opt-out-error').style.display = 'none';
    };

    window.loadFeatureCallback = function(error) {
      if (error) {
        throw error;
      }
      canOptOut().then((showForm) => {
        if (showForm) {
          setupForm();
          if (getUrlParam('success') === 'true') {
            showSuccessMessage();
          } else if (getUrlParam('success') === 'false') {
            showErrorMessage();
          }
        } else {
          showNotApplicableMessage();
        }
      });
    };

    window.canOptOut = function() {
      if (isAdminPreviewMode()) {
        return getSaleofDataRegions().then((regions) => {
          return regions.includes(window.Shopify.country);
        });
      }
      var customerPrivacyApi = window.Shopify.customerPrivacy;
      if (customerPrivacyApi.unstable) {
        return Promise.resolve(customerPrivacyApi.unstable.saleOfDataRegion());
      }
      return Promise.resolve(customerPrivacyApi.getRegulation() === 'CCPA');
    };

    window.ccpaOptOutLoader = function() {
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        loadFeatureCallback,
      );
    };

    window.optOutOnLoad = function() {
      var optOutSubmitButton = document.getElementById('pc--opt-out-button');
      var optOutForm = document.getElementById('pc--opt-out-form');

      optOutSubmitButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (!optOutForm.reportValidity()) {
          return;
        }
        if (document.getElementById('hcaptcha')) {
          hcaptcha.execute();
        } else {
          submitOptOutForm();
        }
      });
    };

    window.liquidAccessToken = function() {
      var shopifyFeatures = document.documentElement.querySelector('#shopify-features');
      if (!shopifyFeatures) {
        return undefined;
      }
      var featuresAccessToken = JSON.parse(shopifyFeatures.textContent || '').accessToken;
      if (!featuresAccessToken) {
        return undefined;
      }
      return featuresAccessToken;
    };

    window.getSaleofDataRegions = async function() {
      var fetchParams = {
        headers: {
          'content-type': 'application/json',
          'x-shopify-storefront-access-token': liquidAccessToken(),
        },
        body: JSON.stringify({
          query: `
            query bannerQuery {
              consentManagement {
                saleOfDataRegions
              }
            }`,
        }),
        method: 'POST',
      };

      return fetch('/api/unstable/graphql.json?fast_storefront_renderer=1', fetchParams)
        .then((response) => {
          if (!response.ok) {
            return response.text().then(text => { throw new Error(text) });
          }
          return response.json();
        })
        .then((respJson) => {
          if (respJson.errors) {
            throw new Error(respJson.errors.map(e => e.message).join(', '));
          }
          else if (!respJson || !respJson.data || !respJson.data.consentManagement || !respJson.data.consentManagement.saleOfDataRegions) {
            throw new Error('Invalid or empty response from the server');
          }
          return respJson.data.consentManagement.saleOfDataRegions;
        })
        .catch((error) => {
          return [];
        });
    };

    window.isAdminPreviewMode = function() {
      var abCookie = document.cookie.split(';').filter((cookie) => cookie.trim().startsWith('_ab='))[0];
      return abCookie ? abCookie.split('=')[1] === '1' : false;
    };

    // Initialize the form
    ccpaOptOutLoader();
  }
}

// Create and register the PrivacyModal element
customElements.define('privacy-modal', PrivacyModal);

// Create the PrivacyModal element and add it to the document
const privacyModal = document.createElement('privacy-modal');
document.body.appendChild(privacyModal);

// Add the button to the footer only for USCA customers
document.addEventListener('DOMContentLoaded', async () => {
  // const isUSCA = await privacyModal.checkRegion();
  // console.log('Region check result in DOMContentLoaded:', isUSCA);
  // if (!isUSCA) {
  //   console.log('Not in correct region, not adding button');
  //   return;
  // }

  // Find the footer menu list
  const footerMenuList = document.querySelector('.footer-block__details-content.list-unstyled');
  if (!footerMenuList) {
    return;
  }

  const link = document.createElement('a');
  link.className = 'link link--text list-menu__item list-menu__item--link';
  link.href = 'javascript:void(0)';
  link.textContent = 'Do Not Sell or Share My Personal Info';
  link.addEventListener('click', (e) => {
    e.preventDefault();
    privacyModal.showModal();
  });

  const listItem = document.createElement('li');
  listItem.appendChild(link);

  // Add the link as the last item in the list
  footerMenuList.appendChild(listItem);
}); 